<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import NewsCard from '@components/ui/cards/news-card.vue'
import Skeleton from '@components/_base-skeleton.vue'
import queryString from 'query-string'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    NewsCard,
    Skeleton,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    excerpt: function(text, limit) {
      return (
        text
          .split(/\s+/)
          .slice(0, limit)
          .join(' ') + '...'
      )
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
  },
  data() {
    return {
      Article: {
        atribut: {
          featured_image: {
            data: {},
          },
          source: {
            data: {},
          },
        },
      },
      RelatedNews: [],
      isLoading: true,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** for SEO, meta and hero */
      featuredImage: '',
      currentUrl: window.location.origin + window.location.pathname,
      pageTitle: 'Loading...',
      pageDescription: '',
      pageMeta: [],
      pageName: 'news-single',
      notFoundState: false,
      origin: window.location.origin,
    }
  },
  mounted() {
    const watchLang = queryString.parse(window.location.search).lang
    if (watchLang) {
      this.getArticle({ lang_relation: watchLang })
    } else {
      this.getArticle()
    }
  },
  methods: {
    getArticle: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'news',
        record_slug: this.$route.params.slug,
        simple: true,
        lang: this.lang,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`

      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        if (data) {
          this.Article = data
          if (
            data.atribut.length !== 0 &&
            data.atribut.featured_image.data[0]
          ) {
            this.featuredImage =
              appConfig.s3_endpoint +
              data.atribut.featured_image.data[0].content
          }
          this.isLoading = false
          this.openComment()
        } else {
          this.isLoading = false
          this.notFoundState = true
        }
        /** FOR SEO AND META TAG PURPOSE */
        this.pageTitle = data.title

        this.pageMeta = [
          {
            name: 'description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          // facebook
          {
            property: 'og:type',
            content: 'article',
          },
          {
            property: 'og:title',
            content: data.title,
          },
          {
            property: 'og:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            property: 'og:image',
            content: this.featuredImage,
          },
          {
            property: 'og:url',
            content: this.currentUrl,
          },
          {
            property: 'og:site_name',
            content: appConfig.title,
          },
          // twitter
          {
            name: 'twitter:title',
            content: data.title,
          },
          {
            name: 'twitter:image',
            content: this.featuredImage,
          },
          {
            name: 'twitter:description',
            content: this.$options.filters
              .plainText(data.content)
              .slice(0, 160),
          },
          {
            name: 'twitter:site',
            content: this.currentUrl,
          },
        ]
      })
    },
    /**
     * Open Comment, this should be in Mixin!
     */
    openComment: function() {
      // momento js
      const momento = document.createElement('script')
      momento.setAttribute('src', 'https://commento.lexikan.id/js/commento.js')
      document.head.appendChild(momento)
    },
  },
}
</script>

<template>
  <div>
    <b-container
      v-if="notFoundState"
      style="min-height: 50vh;display:flex;align-items:center"
    >
      <b-row :class="$style.errorHandler">
        <b-col cols="12">
          <p>{{ $t('news_no_data') }} </p>
          <a
            class="text-primary"
            pointer
            @click="$router.push({ name: 'news' })"
            >{{ $t('back_page') }}</a
          >
        </b-col>
      </b-row>
    </b-container>
    <Skeleton
      v-if="isLoading && notFoundState === false"
      :type="pageName === 'default' ? 'default' : pageName"
    ></Skeleton>
    <Layout v-else-if="isLoading === false && notFoundState === false">
      <section :class="$style.newsDetail" :style="{ minHeight: '60vh' }">
        <b-container class="my-5">
          <b-row class="">
            <div class="col-12">
              <!-- Breadcrumb -->
              <ol class="breadcrumb mb-4 pl-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item"
                  ><router-link to="/news">{{ $t('News') }}</router-link></li
                >
                <li class="breadcrumb-item active" aria-current="page">{{
                  Article.title
                }}</li>
              </ol>
              <!-- end of Breadcrumb -->

              <!-- News Content -->
              <div :class="$style.newsBlock">
                <img
                  v-if="featuredImage"
                  :src="featuredImage"
                  class="img-fluid"
                  :alt="Article.title"
                />

                <h1>
                  {{ Article.title }}
                </h1>
                <p v-if="Article.atribut.length !== 0"
                  >Source link:
                  <a
                    v-for="(source, index) in Article.atribut.source.data"
                    :key="index"
                    :href="source.content ? source.content : '#!'"
                    >{{
                      source.caption
                        ? index > 0
                          ? ', ' + source.caption
                          : source.caption
                        : '-'
                    }}</a
                  >
                </p>
                <p>{{ Article.created_at_format }}</p>

                <div
                  v-html-safe="Article.content"
                  class="title-news my-4"
                  :class="$style.newsContent"
                >
                </div>
              </div>
              <div class="clear"></div>
              <!-- end of News Content -->

              <!-- News footer -->
              <div class="footer-news my-5">
                <div class="row"> </div>

                <p v-if="Article.atribut.length !== 0"
                  >Source access date:
                  <span
                    v-for="(date, index) in Article.atribut.source_access_date
                      .data"
                    :key="index"
                  >
                    {{ date.content }}
                  </span>
                </p>

                <span class="pl-0 pl-lg-5 mt-3 mt-lg-0 d-block d-lg-inline">
                  Share :
                  <ShareNetwork
                    network="facebook"
                    :url="currentUrl"
                    :title="Article.title"
                    :description="Article.content | plainText | excerpt(25)"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_FB.png"
                      alt=""
                      :class="$style.sosmed"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="twitter"
                    :url="`${origin}/sharer.php?page=news&slug=${Article.slug}`"
                    :title="Article.title"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_Twitter.png"
                      alt=""
                      :class="$style.sosmed"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="linkedin"
                    :title="Article.title"
                    :url="currentUrl"
                  >
                    <img
                      src="@assets/icons/Icon_Linkedin.png"
                      alt=""
                      :class="$style.sosmed"
                    />
                  </ShareNetwork>
                </span>
              </div>
              <!-- end of News footer -->
            </div>
          </b-row>
        </b-container>
      </section>

      <section v-if="false" :class="$style.relatedNews">
        <b-container class="my-4">
          <b-row>
            <b-col cols="12">
              <h2 :style="{ color: 'gray' }">Related News</h2>
            </b-col>
            <div
              v-for="(related, index) in RelatedNews"
              :key="index"
              class="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-stretch"
            >
              <NewsCard
                :title="related.title | capitalize"
                :content="related.content | excerpt(10)"
                :date="related.created_at_format"
                heading-tag="h5"
                :img-src="related.thumbnail"
                img-width="10rem"
                padding="2rem 1rem"
                :url="'/news/' + related.ID"
                :border="true"
              >
              </NewsCard>
            </div>
          </b-row>
        </b-container>
      </section>

      <!-- Comment section -->
      <section id="comment">
        <b-container>
          <b-row class="justify-content-center">
            <b-col cols="lg-8 my-5">
              <h2
                class="mb-5"
                :style="{ color: 'gray', textAlign: 'center' }"
                >{{ $t('Comments') }}</h2
              >
              <div id="commento"></div>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </Layout>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.newsBlock {
  min-height: 200px;
  img {
    float: left;
    width: 40%;
    height: auto;
    margin: 0 20px 10px 0;
  }
  .newsContent {
    text-align: justify;
  }
}

.clear {
  clear: both;
}

.sosmed {
  width: 48px;
  margin-right: 0.5rem;
  cursor: pointer;
  &:first-child {
    margin-left: 0.75rem;
  }
}

@media only screen and (max-width: $mobile-sm) {
  .newsBlock {
    img {
      width: 100%;
    }
  }
}
</style>
